function getPostingsState(state) {
  return {
    postings: state.postings.postings,
    postingCount: state.postings.numberOfPostings,
    isLoading: state.postings.loading,
    fetchError: state.postings.fetchPostingsError,
    recievedPostingsResponse: state.postings.recievedPostingsResponse,
    isComplete: state.postings.isComplete,
    isCompleteError: state.postings.isCompleteError,
    isCompleteLoading: state.postings.isCompleteLoading,
    duplicatedCount: state.postings.duplicatedCount,
    facets: state.postings.facets,
    nearEndPostingCount: state.postings.nearEndPostingCount,
    dashboardInfo: state.postings.dashboardInfo,
    loadingDashboardInfo: state.postings.loadingDashboardInfo,
    dashboardInfoError: state.postings.dashboardInfoError,
    finishReason: state.postings.finishReason,
    loadingFinishReason: state.postings.loadingFinishReason,
    postingsQualityToExport: state.postings.postingsQualityToExport,
    postingsQualityToExportIsLoading: state.postings.postingsQualityToExportIsLoading,
    postingsQualityToExportCompleted: state.postings.postingsQualityToExportCompleted,
    postingsQualityToExportFailed: state.postings.postingsQualityToExportFailed
  };
}

export { getPostingsState };
